import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { take } from 'rxjs/operators';
import { SigneringAnmodningInfo } from 'src/app/api/models/signering-anmodning-info';
import { SigneringService } from 'src/app/api/services';
import { FileService } from 'src/app/core/services/file/file.service';

@Component({
  selector: 'bom-digital-signering',
  templateUrl: './digital-signering.component.html',
  styleUrls: ['./digital-signering.component.scss'],
})
export class DigitalSigneringComponent implements OnInit {
  signeringAnmodingInfo: SigneringAnmodningInfo;
  errorMessage = new BehaviorSubject<string>(null);
  ticket: string;
  encodedTicket: string;
  isDownloading = false;
  isFetchingSigningRequest = false;
  state$: Observable<Record<string, unknown>>;

  constructor(
    private route: ActivatedRoute,
    private signeringService: SigneringService,
    private fileService: FileService
  ) { }

  ngOnInit() {
    this.route.params.pipe(take(1)).subscribe(params => {
      this.encodedTicket = encodeURIComponent(params.ticket);
      this.ticket = params.ticket;
      this.signeringService.getAnmodning(this.ticket).subscribe({
        next: signeringAnmodingInfo => {
          this.signeringAnmodingInfo = signeringAnmodingInfo;
          this.errorMessage.next(null);
        },
        error: e => {
          if (e.status === 400) {
            const errors = e.error;
            this.errorMessage.next(errors);
          } else {
            throw e;
          }
        },
      });
    });
  }

  downloadDokumentation() {
    this.isDownloading = true;
    this.fileService
      .download('Signering dokumentation.pdf', 'signering/ticketdokument', {
        ticket: this.encodedTicket,
      })
      .subscribe({
        next: () => {
          this.isDownloading = false;
        },
        error: err => {
          this.isDownloading = false;
          return throwError(err);
        },
      });
  }
}
